import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@dhn/components/ui/button";
import { cn } from "@dhn/lib/utils";
import DynamicBreadcrumb from "../../@dhn/components/dynamic-bread-crumb/DynamicBreadcrumb";
import { MENU_CONFIG } from "./constants/menuConfig";
import useNavbarDoctorOffice from "./hooks/useNavbarDoctorOffice";
import NavMenu from "./components/NavMenu";
import NavbarRight from "./components/NavbarRight";
import PrescriptionAvailability from "./components/PrescriptionAvailability";
import { PRESCRIPTION_PURCHASE_ENFORCED } from "./hooks/usePrescriptionAvailability";
import CompanyLogo from "@dhn/components/CompanyLogo";
// Rediseño del navbar; quitar esta línea vuelve al diseño anterior.
import "./navbar-refresh.css";

const NavbarDoctorOffice = ({ user, dataDoctor, profile }) => {
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const {
    permissionViews,
    branchOfficeOption,
    currentBranchName,
    selectedBranchId,
    logo,
    companyInfo,
    companyName,
    isCompanyLogoLoading,
    signOut,
    changeBranch,
    isPermissionsReady,
    prescriptionAvailableAmount,
  } = useNavbarDoctorOffice({ dataDoctor, profile });

  if (!isPermissionsReady) {
    return (
      <div className="tw-flex tw-justify-center tw-py-12 tw-text-sm tw-font-medium tw-text-muted-foreground">
        Loading...
      </div>
    );
  }

  return (
    <div className="doctor-office-shell">
      <header className="doctor-office-navbar tw-sticky tw-top-0 tw-z-40 tw-border-b tw-border-clinic-line/80 tw-bg-white/95 tw-shadow-clinic-soft tw-backdrop-blur">
        <nav className="doctor-office-navbar__inner tw-flex tw-min-h-[88px] tw-w-full tw-flex-wrap tw-items-center tw-gap-3 tw-px-4 tw-py-3 xl:tw-flex-nowrap xl:tw-px-6">
          <NavLink
            to="/"
            className="doctor-office-navbar__brand tw-flex tw-items-center tw-rounded-md tw-pr-2 tw-no-underline focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring"
          >
            <CompanyLogo
              companyInfo={companyInfo}
              loading={isCompanyLogoLoading}
              alt={companyName}
              className="doctor-office-navbar__logo tw-h-16 tw-w-auto tw-object-contain sm:tw-h-20 xl:tw-h-24"
              loaderClassName="doctor-office-navbar__logo tw-h-16 tw-w-28 sm:tw-h-20 xl:tw-h-24"
              loaderStyle={{ fontSize: 20, color: "#1f7db7" }}
            />
          </NavLink>

          <Button
            type="button"
            variant="outline"
            size="icon"
            className="doctor-office-navbar__toggle tw-ml-auto tw-border-clinic-line tw-text-clinic-ink xl:tw-hidden"
            onClick={toggle}
            aria-expanded={isOpen}
            title="Alternar navegación"
            aria-label="Alternar navegación"
          >
            {isOpen ? (
              <X className="tw-h-5 tw-w-5" />
            ) : (
              <Menu className="tw-h-5 tw-w-5" />
            )}
          </Button>

          <div
            className={cn(
              "doctor-office-navbar__content tw-w-full tw-min-w-0 tw-items-center tw-gap-4 xl:tw-flex xl:tw-w-auto xl:tw-flex-1",
              isOpen ? "tw-block" : "tw-hidden xl:tw-flex",
              isOpen && "doctor-office-navbar__content--open",
            )}
          >
            <NavMenu
              permissionViews={permissionViews}
              pathname={pathname}
              menuConfig={MENU_CONFIG}
            />

            <NavbarRight
              user={user}
              dataDoctor={dataDoctor}
              profileName={dataDoctor?.profileName || profile?.name}
              permissionViews={permissionViews}
              branchOfficeOption={branchOfficeOption}
              currentBranchName={currentBranchName}
              selectedBranchId={selectedBranchId}
              onChangeBranch={changeBranch}
              logo={logo}
              onSignOut={signOut}
            />
          </div>
        </nav>
      </header>

      {pathname !== "/" && (
        <DynamicBreadcrumb
          actions={
            // Los recetarios solo se muestran donde su compra está activa.
            PRESCRIPTION_PURCHASE_ENFORCED && (
              <PrescriptionAvailability amount={prescriptionAvailableAmount} />
            )
          }
        />
      )}
    </div>
  );
};

export default NavbarDoctorOffice;
